module.exports = __webpack_public_path__ + "img/health.7ac603a8.webp";